﻿/**
 * setting-modal.controller
 * @namespace portal
 */

(function () {
	'use strict';

	/** get the angular module and add controller */
	angular.module('nha.portal').controller('setting-modal.controller', settingModalController);

	/** setup injection */
	settingModalController.$inject = ['$uibModalInstance', 'config.repository', 'setting', 'allSettings', 'parentInit'];

	/** implementation */
	function settingModalController($uibModalInstance, configRepo, setting, allSettings, parentInit) {
		/** pubic properties */
		var vm = this;
		vm.original = setting || createSetting();
		vm.setting = angular.copy(vm.original);
		vm.environments = [];
		vm.loading = false;
		vm.saving = false;
		vm.isAllEnv = checkIsAllEnv();
		vm.isNew = setting ? false : true;

		/** public methods (portalLink) */
		vm.save = save;
		vm.remove = remove;
		vm.isValidNewSettingKey = isValidNewSettingKey;
		vm.checkEnvValues = checkEnvValues;
		vm.close = close;
		vm.cancel = cancel;

		/** run init */
		init();

		/** public method implementations */

		/** save the link */
		function save() {
			/** flip saving flag */
			vm.saving = true;

			/** set the settingKey value */
			vm.original.settingKey = vm.setting.settingKey;
			vm.original.settingValues = [];

			/** check the isAllEnv flag */
			if (vm.isAllEnv) {
				/** get the all environment value */
				var value = vm.environments.find(function (env) { return env.environmentID === 1; }).value;

				/** add the all environment setting value */
				vm.original.settingValues.push({
					settingID: vm.setting.settingID,
					environmentID: 1,
					settingValue: value
				});
			} else {
				/** cycle through environment values to add settingValue for each */
				vm.environments.forEach(function (env) {
					/** ignore all env option */
					if (env.environmentID !== 1 && env.value !== null && env.value.length > 0) {
						/** add the all environment setting value */
						vm.original.settingValues.push({
							settingID: vm.setting.settingID,
							environmentID: env.environmentID,
							settingValue: env.value
						});
					}
				});
			}

			/** send the request to activate/deactivate */
			configRepo.saveSetting(vm.original).then(function(newSetting) {
				/** show the success message */
				swal({
					'title': 'Save Complete',
					'text': 'The processing has completed. The link was saved successfully.',
					'type': 'success'
				}, function() {
					/** flip saving flag */
					vm.saving = false;
					
					/** set original and copy */
					if (newSetting) {
						vm.original = newSetting;
						vm.setting = angular.copy(vm.original);
					}

					/** set isNew to false */
					vm.isNew = false;
					vm.isAllEnv = checkIsAllEnv();

					/** reinitialize the parent */
					parentInit();
				});
			});
		}

		/** remove the setting */
		function remove() {
			/** show swal confirmation window */
			swal({
				'title': 'Are you sure you want to delete this setting?',
				'type': 'warning',
				'showCancelButton': true,
				'confirmButtonText': 'Yes, Delete It!',
				'closeOnConfirm': false
			}, function(isConfirm) {
				/** check the isConfirm flag */
				if (isConfirm) {
					/** flip saving flag */
					vm.saving = true;

					/** send the request to activate/deactivate */
					configRepo.removeSetting(vm.setting.settingID).then(function() {
						/** flip saving flag */
						vm.saving = false;

						/** show the success message */
						swal({
							'title': 'Delete Complete',
							'text': 'The processing has completed. The setting was deleted successfully.',
							'type': 'success'
						}, function() {
							/** reinitialize the parent */
							parentInit();

							/** close modal */
							close();
						});
					});
				}
			});
		}

		/** check that at least one environment has a value */
		function checkEnvValues() {
			if (vm.isAllEnv) {
				if (vm.environments.find(function (env) { return env.environmentID === 1 && env.value !== null; })) return true;
			} else {
				var hasValue = false;
				vm.environments.forEach(function (env) {
					if (env.environmentID !== 1 && env.value !== null && env.value !== '') {
						hasValue = true;
					}
				});
				return hasValue;
			}

			return false;
		}

		/** check that the key isn't already in use */
		function isValidNewSettingKey() {
			if (vm.isNew) {
				if (allSettings.find(function (s) { return s.settingKey === vm.setting.settingKey; })) {
					return false;
				}
			}

			return true;
		}

		/** close the modal */
		function close() {
			$uibModalInstance.close();
		}

		/** cancel the modal */
		function cancel() {
			$uibModalInstance.dismiss();
		}

		/** private methods */

		/** initialize */
		function init() {
			/** toggle loading flag */
			vm.loading = true;

			/** load the environments */
			configRepo.getEnvironments().then(function (envs) {
				/** set environments */
				vm.environments = envs.map(function (env) {
					/** find the environment value */
					var envSettingValue = null;
					if (vm.setting.settingValues) {
						envSettingValue = vm.setting.settingValues.find(function (sv) {
							return sv.environmentID === env.environmentID;
						});
					}

					/** return an object */
					env.value = envSettingValue ? envSettingValue.settingValue : null;
					return env;
				});

				/** toggle loading flag */
				vm.loading = false;
			});

			/** set focus on the */
			$uibModalInstance.rendered.then(function() {
				$('.modal-body div input[type="text"]:first').focus();
			});
		}

		/** check whether this is an all environment setting or not */
		function checkIsAllEnv() {
			if (vm.setting.settingValues.length === 1 && vm.setting.settingValues.find(function (sv) { return sv.environmentID === 1; })) return true;
			return false;
		}

		/** create an empty setting entity */
		function createSetting() {
			return {
				settingID: 0,
				settingKey: '',
				settingTypeID: 4,
				locationID: 1,
				isProtected: false,
				createdByUserName: '',
				lastModifiedByUserName: '',
				settingValues: []
			};
		}
	}
})();